/**
 * Section Details Store
 * Zustand store for managing section details state
 */

import { create } from 'zustand';
import { fetchSectionById } from '../services/sections.service';
import type { SectionDetail } from '../interfaces/apiInterfaces/sections';

interface SectionDetailsStore {
  section: SectionDetail | null;
  isLoading: boolean;
  error: string | null;
  load: (sectionId: string) => Promise<void>;
  reset: () => void;
}

export const useSectionDetailsStore = create<SectionDetailsStore>((set) => ({
  section: null,
  isLoading: false,
  error: null,

  load: async (sectionId: string) => {
    set({ isLoading: true, error: null });
    try {
      const section = await fetchSectionById(sectionId);
      set({ section, isLoading: false });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load section details';
      set({ error: message, isLoading: false });
      console.error('Failed to load section details:', error);
    }
  },

  reset: () => set({ section: null, isLoading: false, error: null }),
}));

